import { Route } from "react-router-dom";
import PurchaseDashboardPage from "@/pages/PurchaseDashboardPage";
import PurchaseSuppliersPage from "@/pages/PurchaseSuppliersPage";
import PurchaseItemsPage from "@/pages/PurchaseItemsPage";
import PurchaseItemFormPage from "@/pages/PurchaseItemFormPage";
import PurchaseCostCentersPage from "@/pages/PurchaseCostCentersPage";
import PurchaseNewSupplierPage from "@/pages/PurchaseNewSupplierPage";
import PurchaseSupplierPage from "@/pages/PurchaseSupplierPage";
import PurchaseDocsPage from "@/pages/PurchaseDocsPage";
import PurchaseBillsPage from "@/pages/PurchaseBillsPage";
import PurchaseDocPage from "@/pages/PurchaseDocPage";
import PurchaseNewDocPage from "@/pages/PurchaseNewDocPage";
import PurchaseReportsPage from "@/pages/PurchaseReportsPage";
import PurchaseConfirmPage from "@/pages/PurchaseConfirmPage";
import PurchaseSettingsPage from "@/pages/PurchaseSettingsPage";
import { MANAGER_ROLES } from "@/utils/role";
import WarehousePage from "@/pages/WarehousePage";
import WarehouseTransferNewPage from "@/pages/WarehouseTransferNewPage";
import WarehouseTransferReceivePage from "@/pages/WarehouseTransferReceivePage";
import WarehouseIssueNewPage from "@/pages/WarehouseIssueNewPage";
import WarehouseCountNewPage from "@/pages/WarehouseCountNewPage";
import WarehouseCountDetailPage from "@/pages/WarehouseCountDetailPage";
import { ProtectedRoute } from "@/routes/ProtectedRoute";
import { FeatureGate } from "@/components/layout/FeatureGate";

const PAGES = [
  { path: "/purchases", element: <PurchaseDashboardPage /> },
  { path: "/purchases/suppliers", element: <PurchaseSuppliersPage /> },
  { path: "/purchases/items", element: <PurchaseItemsPage /> },
  { path: "/purchases/items/new", element: <PurchaseItemFormPage /> },
  { path: "/purchases/items/:itemId", element: <PurchaseItemFormPage /> },
  { path: "/purchases/cost-centers", element: <PurchaseCostCentersPage /> },
  { path: "/purchases/suppliers/new", element: <PurchaseNewSupplierPage /> },
  { path: "/purchases/suppliers/:supplierId", element: <PurchaseSupplierPage /> },
  { path: "/purchases/requisitions", element: <PurchaseDocsPage docType="requisition" /> },
  { path: "/purchases/requisitions/new", element: <PurchaseNewDocPage tab="requisitions" docType="requisition" /> },
  { path: "/purchases/orders", element: <PurchaseDocsPage docType="purchase_order" /> },
  { path: "/purchases/orders/new", element: <PurchaseNewDocPage tab="orders" docType="purchase_order" /> },
  { path: "/purchases/docs/:docId", element: <PurchaseDocPage /> },
  { path: "/purchases/bills", element: <PurchaseBillsPage /> },
  { path: "/purchases/reports", element: <PurchaseReportsPage /> },
  { path: "/purchases/settings", element: <PurchaseSettingsPage /> },
  { path: "/warehouse", element: <WarehousePage /> },
  { path: "/warehouse/transfers/new", element: <WarehouseTransferNewPage /> },
  { path: "/warehouse/transfers/:tid/receive", element: <WarehouseTransferReceivePage /> },
  { path: "/warehouse/issues/new", element: <WarehouseIssueNewPage /> },
  { path: "/warehouse/counts/new", element: <WarehouseCountNewPage /> },
  { path: "/warehouse/counts/:cid", element: <WarehouseCountDetailPage /> },
];

// مسارات المشتريات: محمية بالدور ومغلقة بمفتاح ميزة `purchases` الذي يفتحه مالك المنصة.
export const purchaseRoutes = [
  // صفحة تأكيد المورّد عامة تماماً: لا تسجيل دخول ولا ميزة — الرمز في الرابط هو الإثبات.
  <Route key="confirm" path="/purchase-confirm/:token" element={<PurchaseConfirmPage />} />,
  ...PAGES.map(({ path, element }) => (
    <Route
      key={path}
      path={path}
      element={
        <ProtectedRoute roles={MANAGER_ROLES}>
          <FeatureGate feature="purchases">{element}</FeatureGate>
        </ProtectedRoute>
      }
    />
  )),
];
